
/* Protopia Ecosystem component */
export interface IPanelMembraneProps {
   
}
const PanelMembrane = (props: IPanelMembraneProps): JSX.Element => {
    return <div className='pe-panel-membrane'>
       
    </div>
}
export default PanelMembrane